"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalCondition = exports.randomFromArray = exports.immuteArray = exports.immute = void 0;
// @ts-ignore
const immute = (target, payload, argParams = {}) => {
    const { merge, path } = Object.assign({ merge: false, path: '' }, argParams);
    const steps = (path || '').split('.');
    const immuted = steps.reduce(
    // @ts-ignore
    ({ parent, root }, step, index) => {
        const newRoot = root || parent;
        const lastStep = index === steps.length - 1;
        if (lastStep && !step)
            return Object.assign(Object.assign({}, newRoot), payload);
        if (lastStep) {
            parent[step] = merge
                ? Object.assign(Object.assign({}, (parent[step] || {})), payload) : payload;
        }
        else {
            parent[step] = Object.assign({}, (parent[step] || {}));
        }
        if (parent[step] === undefined)
            delete parent[step];
        return lastStep
            ? newRoot
            : {
                parent: parent[step],
                root: newRoot,
            };
    }, {
        parent: Object.assign({}, target),
    });
    return immuted;
};
exports.immute = immute;
// @ts-ignore
const immuteArray = (array, index, entry) => [
    ...array.slice(0, index),
    Object.assign(Object.assign({}, array[index]), entry),
    ...array.slice(index + 1),
];
exports.immuteArray = immuteArray;
// @ts-ignore
const randomFromArray = (array) => array[Math.floor(Math.random() * array.length)];
exports.randomFromArray = randomFromArray;
const evalCondition = (value, operator, target) => {
    if (value === undefined)
        return undefined;
    if (operator === '=')
        return value === target;
    if (operator === '<')
        return value < target;
    if (operator === '>')
        return value > target;
    if (operator === '<=')
        return value <= target;
    if (operator === '>=')
        return value >= target;
    if (operator === '!=')
        return value !== target;
    if (operator === 'between')
        return value >= target[0] && value <= target[1];
};
exports.evalCondition = evalCondition;
